import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/siteInfo";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 mt-16 md:mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-2xl font-brand text-primary-400">每日黑料</span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              每日黑料大赛入口，黑料每日爆料，网红塌房现场直击。聚焦每日黑料吃瓜网最新地址，每日更新最热吃瓜内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              <a href="#footer-categories">热门分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 hover:decoration-primary-400 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              <a href="#footer-quick-links">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 hover:decoration-primary-400 whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/meiri-dasai" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 hover:decoration-primary-400 whitespace-nowrap">
                每日黑料大赛
              </Link>
              <Link to="/category/chigua-baoliao" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 hover:decoration-primary-400 whitespace-nowrap">
                每日黑料吃瓜网
              </Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 hover:decoration-primary-400 whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              <a href="#footer-contact">联系我们</a>
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-300">
              <span className="whitespace-nowrap">邮箱：{siteInfo.email}</span>
              <span className="whitespace-nowrap">微信：{siteInfo.wechat}</span>
              <span className="whitespace-nowrap">微博：{siteInfo.weibo}</span>
              <span className="leading-relaxed mt-1">{siteInfo.address}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 whitespace-nowrap" rel="nofollow">
              <i className="ri-wechat-line w-4 h-4 flex items-center justify-center inline mr-1"></i>
              微信
            </a>
            <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 whitespace-nowrap" rel="nofollow">
              <i className="ri-weibo-line w-4 h-4 flex items-center justify-center inline mr-1"></i>
              微博
            </a>
            <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 whitespace-nowrap" rel="nofollow">
              <i className="ri-bilibili-line w-4 h-4 flex items-center justify-center inline mr-1"></i>
              B站
            </a>
          </div>
          <p className="text-sm text-foreground-400 text-center">
            &copy; {new Date().getFullYear()} 每日黑料 MeiriHeiliao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors underline decoration-foreground-700 whitespace-nowrap" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}